import { ThemeState, reducer } from './ThemeOptions';

export const themeReducer = {
  theme: reducer
};

export interface ThemeStoreState {
  theme: ThemeState;
}
